import type { SVGProps } from "react";

/**
 * Rest / let rest — a plate with a dome lid and Zzz indicator.
 */
export function RestIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Plate */}
      <ellipse
        cx={24}
        cy={36}
        rx={18}
        ry={4}
        fill="currentColor"
        opacity={0.15}
      />
      <ellipse
        cx={24}
        cy={36}
        rx={18}
        ry={4}
        stroke="currentColor"
        strokeWidth={1}
        opacity={0.3}
        fill="none"
      />
      {/* Dome lid */}
      <path
        d="M12 34c0-8 5-16 12-16s12 8 12 16"
        fill="currentColor"
        opacity={0.1}
      />
      <path
        d="M12 34c0-8 5-16 12-16s12 8 12 16"
        stroke="currentColor"
        strokeWidth={1.2}
        opacity={0.4}
        fill="none"
      />
      {/* Lid knob */}
      <circle cx={24} cy={18} r={2} fill="currentColor" opacity={0.5} />
      {/* Zzz */}
      <text
        x={34}
        y={16}
        fontFamily="serif"
        fontSize={10}
        fill="currentColor"
        opacity={0.5}
        fontWeight="lighter"
      >
        z
      </text>
      <text
        x={38}
        y={10}
        fontFamily="serif"
        fontSize={8}
        fill="currentColor"
        opacity={0.35}
        fontWeight="lighter"
      >
        z
      </text>
      <text
        x={41}
        y={5}
        fontFamily="serif"
        fontSize={6}
        fill="currentColor"
        opacity={0.2}
        fontWeight="lighter"
      >
        z
      </text>
    </svg>
  );
}
